import Api, {
  baseURL,
  requestOptionsGET,
  requestOptionsPOST,
  requestOptionsPOSTForFiles,
  requestOptionsPUTWithBody,
  requestOptionsDELETE,
  requestOptionsPUT
} from '../api';
import newFetch from '../utils/newFetch';
import { UrlMaker } from '@/utils/urlParamsMaker';

const getInvoicesReceivableParams = (params, baseUrl) => {
  const {
    pageNumber,
    pageSize,
    createdAtStart,
    createdAtEnd,
    receiptForecastStart,
    receiptForecastEnd,
    paymentReceivedStart,
    paymentReceivedEnd,
    statusId,
    senderId,
    numberInvoiceId,
    externalInvoiceNumber,
    boardingNumbers,
    cteNumbers
  } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('PageNumber', pageNumber);
  urlMaker.addKeyAndString('PageSize', pageSize);
  urlMaker.addKeyAndString('CreatedAtStart', createdAtStart);
  urlMaker.addKeyAndString('CreatedAtEnd', createdAtEnd);
  urlMaker.addKeyAndString('ReceiptForecastStart', receiptForecastStart);
  urlMaker.addKeyAndString('ReceiptForecastEnd', receiptForecastEnd);
  urlMaker.addKeyAndString('PaymentReceivedStart', paymentReceivedStart);
  urlMaker.addKeyAndString('PaymentReceivedEnd', paymentReceivedEnd);
  urlMaker.addKeyAndString('SenderId', senderId);
  urlMaker.addKeyAndString('StatusId', statusId);
  urlMaker.addKeyAndBoolean('NumberInvoiceId', numberInvoiceId);
  urlMaker.addKeyAndBoolean('ExternalInvoiceNumber', externalInvoiceNumber);
  urlMaker.addKeyAndArray('BoardingNumbers', boardingNumbers);
  urlMaker.addKeyAndArray('CteNumbers', cteNumbers);

  return urlMaker.getURL();
};

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getInvoicesReceivable(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getInvoicesReceivableParams(params, Api.getInvoicesReceivable),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  createInvoiceReceivable(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createInvoice, requestOptionsPOST(localStorage.getItem('accessToken'), payload))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  updateInvoiceReceivable(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateInvoiceReceivable,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), payload)
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  undoInvoiceReceivable(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.undoInvoice + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchInvoicesDetails(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getDetailsInvoice + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchInvoiceStatus() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getInvoiceStatus, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getInvoicesByShipper(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getInvoicesReceivableParams(params, Api.getInvoicesByShipper),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  approveInvoiceByShipper(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.approveInvoiceByShipper + id, requestOptionsPUT(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  rejectInvoiceByShipper(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.rejectInvoiceByShipper,
        requestOptionsPUTWithBody(localStorage.getItem('accessToken'), payload)
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  async exportInvoiceSheet(_, params = { pageSize: 1000 }) {
    const obj = requestOptionsPOSTForFiles(localStorage.getItem('accessToken'));
    const URL = baseURL + getInvoicesReceivableParams(params, Api.reportInvoice);

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  },

  async exportInvoiceSheetByShipper(_, params = { pageSize: 1000 }) {
    const obj = requestOptionsPOSTForFiles(localStorage.getItem('accessToken'));
    const URL = baseURL + getInvoicesReceivableParams(params, Api.reportInvoiceByShipper);

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.error(error);
    }
  },

  async exportPdfInvoice(_, id) {
    const obj = requestOptionsGET(localStorage.getItem('accessToken'));
    const URL = baseURL + (Api.downloadPDFInvoice + id);

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log(error);
      console.error(error);
    }
  },

  getDetailsEmailInvoiceHistory(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getDetailsEmailInvoiceHistory + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  sendEmailInvoice(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.sendEmailInvoice + id, requestOptionsPOST(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
